import { render } from "./fivePage.vue?vue&type=template&id=1558c4ac&scoped=true"
import script from "./fivePage.vue?vue&type=script&lang=js"
export * from "./fivePage.vue?vue&type=script&lang=js"

import "./fivePage.vue?vue&type=style&index=0&id=1558c4ac&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1558c4ac"]])

export default __exports__